export const errorNewPassword =
  'New password cannot be the same as the old password.';
